/*
 * Thunderstorm is a full web app framework!
 *
 * Typescript & Express backend infrastructure that natively runs on firebase function
 * Typescript & React frontend infrastructure
 *
 * Copyright (C) 2020 Adam van der Kruk aka TacB0sS
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { Dispatcher, Module } from '@nu-art/ts-common';
import { ModuleFE_XHR } from './http/ModuleFE_XHR.js';
import { ApiDef_ForceUpgrade, HeaderKey_AppVersion, HeaderKey_BrowserType, HttpMethod } from '@nu-art/thunderstorm-shared';
import { browserType } from '../utils/tools.js';
import { apiWithQuery } from '../core/typed-api.js';
const dispatch_onUpgradeRequired = new Dispatcher('__onUpgradeRequired');
class ModuleFE_ForceUpgrade_Class extends Module {
    v1;
    constructor() {
        super();
        this.v1 = {
            assertAppVersion: apiWithQuery(ApiDef_ForceUpgrade.v1.assertAppVersion)
        };
    }
    init() {
        ModuleFE_XHR.addDefaultHeader(HeaderKey_AppVersion, `${process.env.appVersion}`);
        ModuleFE_XHR.addDefaultHeader(HeaderKey_BrowserType, `${browserType()}`);
    }
    compareVersion = () => {
        const def = { method: HttpMethod.GET, path: this.config.assertVersionUrl };
        // this.v1.assertAppVersion({}).execute((response) => {
        // 	dispatch_onUpgradeRequired.dispatchModule(response);
        // });
        ModuleFE_XHR
            .createRequest(def)
            .setRelativeUrl(this.config.assertVersionUrl)
            .execute((response) => {
            dispatch_onUpgradeRequired.dispatchModule(response);
        });
    };
    async __postInit() {
    }
}
export const ModuleFE_ForceUpgrade = new ModuleFE_ForceUpgrade_Class();
//# sourceMappingURL=ModuleFE_ForceUpgrade.js.map